import { render } from "./SignUp.vue?vue&type=template&id=853f9190&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=853f9190&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853f9190"]])

export default __exports__